import styled from 'styled-components';

// A global `svg { pointer-events: none }` reset cascades onto the Highcharts
// SVG (pointer-events is inherited), leaving its elements non-interactive.
// The app's other charts are bar/line — they hover-detect via the container's
// k-d tree (coordinate search) and so are unaffected. A treemap, however, is a
// `directTouch` series with no k-d tree: Highcharts fires hover on the box SVG
// elements themselves, so they must receive pointer events or the tooltip
// never shows. Re-enable pointer events for this chart's SVG only.
const TreemapChart = styled.div({
  '.highcharts-root': {
    pointerEvents: 'auto',
  },
});

export { TreemapChart };
